import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuthState from "../Utils/store";
import { ROUTE_PATHS } from "./constants";

type Props = { children: React.ReactNode };

const RefCodeProtectedRoute = ({ children }: Props) => {
  const location = useLocation();
  const { isLoggedIn } = useAuthState();
  const { paymentMethod } = useAuthState();
  return paymentMethod && isLoggedIn() ? (
    <>{children}</>
  ) : (
    <Navigate
      to={ROUTE_PATHS.DEFAULT_PAYMENTS}
      state={{ from: location }}
      replace
    />
  );
};

export default RefCodeProtectedRoute;
